// const BASE_URL_API = "http://localhost:2010" //
// const BASE_URL = "http://localhost:3000" //
// const BASE_URL = 'https://affaadmin.teknologi40.com/'; //
// const BASE_URL_API = 'https://apiaffa.teknologi40.com/'; //
const BASE_URL = 'https://wms.affa.co.id/'; //
const BASE_URL_API = 'https://apiwms.affa.co.id/'; //

// var BASE_URL_API = 'mongodb://dani:dani@103.151.191.89:27017/portaldadi1';
// const BASE_URL_API = "http://localhost:501"; //

// const BASE_URL_API = StaticVar.URL_API; //
export default {
	URL_API: BASE_URL_API,
	BASE_URL,
	isLocal: false,
	// URL_REPO: `${BASE_URL_API}/contentrepo`,
	// URL_REPO_FASYANKES: `${BASE_URL_API}/medicalrepo`,
};
